import React from 'react';
import { Box, Menu, MenuItem } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import uuid from 'uuid';
import { vernacularLanguageList } from '../../utils/constants';
import {
  setPostLanguage,
  getPostLanguage,
  getCurrentUser,
  setCurrentUser,
} from '../../services/authService';
import { getUuid } from '../../utils/userUtil';
import userService from '../../services/userService';

const LanguageMenu = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const selectedLanguage = getPostLanguage();
  const user = getCurrentUser();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  async function updateLanguageCall() {
    const deviceGuid = getUuid() ? getUuid() : uuid();
    const request = {
      device_guid: deviceGuid,
      device_id: 'web-pwa',
      device_type: 'android',
      device_name: 'web',
      locale: 'eng/en',
      time_zone: 'usa',
      app_version: '8.2.3',
      user_id: user && user.id,
    };
    await userService.updateUserLanguage(selectedLanguage, request);
  }

  const setLanguage = (selectedLanguage) => {
    setPostLanguage(selectedLanguage);
    const userLanguageRequest = { ...user, currentLanguage: selectedLanguage };
    setCurrentUser(userLanguageRequest);
    updateLanguageCall();
    setAnchorEl(null);
    window.location.reload();
  };
  return (
    <React.Fragment>
      <Box className={classes.customLanguageBadge}>
        <Box onClick={handleClick}>
          {selectedLanguage && selectedLanguage.toUpperCase()}
        </Box>
      </Box>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {vernacularLanguageList &&
          vernacularLanguageList.map((option) => (
            <MenuItem
              key={option.key}
              className={
                option.key === selectedLanguage
                  ? `${classes.menuItem} ${classes.selectedMenu}`
                  : `${classes.menuItem}`
              }
              onClick={() => setLanguage(option.key)}
            >
              {option.value} {option.name}
            </MenuItem>
          ))}
      </Menu>
    </React.Fragment>
  );
};
const useStyles = makeStyles((theme) => ({
  customLanguageBadge: {
    background: 'rgb(0,0,0, 0.295596)',
    borderRadius: '50%',
    padding: theme.spacing(1),
    margin: theme.spacing(2),
    width: '28px',
    height: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  menuItem: {
    minHeight: '30px',
  },
  selectedMenu: {
    background: theme.palette.grey['200'],
  },
}));
export default LanguageMenu;
